import { render, staticRenderFns } from "./product-item-card.vue?vue&type=template&id=58bf52a4&scoped=true&lang=pug"
import script from "./product-item-card.js?vue&type=script&lang=js&external"
export * from "./product-item-card.js?vue&type=script&lang=js&external"
import style0 from "./product-item-card.vue?vue&type=style&index=0&id=58bf52a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bf52a4",
  null
  
)

export default component.exports